<div class="accordion-title">
    <button class="accordion" (click)="toggleAccordian($event, panel)">
        <span class="ag-group-contracted" ref="eContracted">
            <svg class="icon-10" [ngClass]="showPanel? 'dropdown-closed' : 'dropdown-open'">
                <use href="../App_Themes/CXone/icons/arrow-right.svg#arrow-right">
                </use>
            </svg>
        </span>
        <span class="text" cvLocalizedText langSection="ETL_Load_From_File" langKey="Sample_File">Sample File</span> </button>
    <div #panel class="panel" [ngClass]="{'mt-2': showPanel }">
        <pre>{{ fileData | json }}</pre>
    </div>
</div>
